/* eslint-disable arrow-parens */
import { Suspense, useEffect, useContext, useMemo, useCallback, useState } from "react";
import { Box, Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../types/components/dialogProps.types";
import PlanHeader from "../../../../shared/enrollment/planCode/PlanHeader";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../../../shared";
import { BBIHealthPlanBrandingV2, DocRxBanner, HealthBenefitBanner } from "../../../../../assets";
import { BrandingProps, BrandingPropsV2 } from "../../../../../types/components/enrollmentProps.types";
import { AuthContext, GroupOwnerContext } from "../../../../../contexts";
import { CommonDetails, StandardDetails } from "../../../../../types/enrollment.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { api } from "../../../../../utils/api";
import { AddEnrollmentPayload } from "../../../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { BBI_PLAN_NAMES } from "../../../../../constants/plan";
import { CheckPreviousCoreEnrollmentQueryTypes } from "../../../../../utils/api/enrollment/getCheckPreviousCoreEnrollment";
import CorePreviousBenefitDisclaimer from "../../../../shared/CorePreviousBenefitDisclaimer/CorePreviousBenefitDisclaimer";
import CorePreviousBenefitDisclaimerV2 from "../../../../shared/CorePreviousBenefitDisclaimer/CorePreviousBenefitDisclaimerV2";
import { generateFileURL } from "../../../../../utils/commonFunctions/generateFileURL";
import SafeHtmlRenderer from "./SafeHtmlRenderer";
import SSM from "../../../../../assets/MATERIAL MODIFICATIONS KSOP/brookshire-smm.pdf";
// import ReactQuill from "react-quill";

// import "react-quill/dist/quill.snow.css";
interface DynamicBrandingPropsV2 {
	status: any;
	openEnrollment: any;
	isActiveEnrollment: boolean;
	changePlanProps: any;
	corePlansForEmployeeClassSpecific: any[];
	selectedPlan: any;
}

const DynamicPlanBranding = ({
	status,
	openEnrollment,
	isActiveEnrollment,
	changePlanProps,
	corePlansForEmployeeClassSpecific,
	selectedPlan,
	setSubmittedEnrollment,
	getEnrollmentInitData,
	member
}: any) => {
	// console.log("openEnrollment=====>branding=====>", status);
	// console.log("isActiveEnrollment===========>", isActiveEnrollment);
	// console.log(
	// 	selectedPlan,
	// 	"enrollmentsrrrrrrrrrrrrrrrrr=====>",
	// 	enrollments,
	// 	selectedPlan.plan_code === enrollments[0].plan.plan_dependencies[0].plan_code
	// );
	const [waiveReason, setWaiveReason] = useState("");
	const { handleChangePlanButtonClick, buttonCaption } = changePlanProps;
	// const { member } = useContext(AuthContext);

	// console.log("member-----------------> 222222222", member);

	const { groupOwner } = useContext(GroupOwnerContext);

	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const [hasPreviousCoreEnrollment, setHasPreviousCoreEnrollment] = useState<boolean>(false);
	const [isWaiveEnrollmentTriggered, setIsWaiveEnrollmentTriggered] = useState(false);
	const [currentPlanShouldEnroll, setCurrentPlanShouldEnroll] = useState<any>({ enroll: true, message: "" });
	// const [isPlanDependencies, setIsPlanDependencies] = useState(false);

	const [planDependencies, setPlanDependencies] = useState<any[]>([]); // {plan_name,plan_code,enrolled_status,is_taken_together}

	// old code for the is_taken_together:true
	// const checkPlanDependenciesEnrolledPriority = useCallback(async () => {
	// 	try {
	// 		let plan_dependencies_array: any = [];

	// 		if (selectedPlan.plan_dependencies && selectedPlan.plan_dependencies.length > 0) {
	// 			plan_dependencies_array = selectedPlan.plan_dependencies
	// 				.filter((plan: any) => plan.is_taken_together)
	// 				.map((plan: any) => ({
	// 					plan_name: plan.plan_name,
	// 					plan_code: plan.plan_code
	// 				}));
	// 		}

	// 		if (plan_dependencies_array.length == 0) {
	// 			return;
	// 		}
	// 		// console.log("plandependencies", plan_dependencies_array);
	// 		// const checkPreviousPayload: CheckPreviousCoreEnrollmentQueryTypes & any = {
	// 		// 	group_number,
	// 		// 	// insured_SSN: SSN,
	// 		// 	status: "ACTIVE",
	// 		// 	$or: JSON.stringify(plan_dependencies_array)
	// 		// };

	// 		// const response = await trackPromise(api.plan.getParticularPlans(checkPreviousPayload));

	// 		const getBenefitsQuery: any = {
	// 			group_number: member.group_number,
	// 			insured_SSN: member.SSN,
	// 			// member_SSN: member.SSN,
	// 			// status: "ACTIVE",
	// 			plan_dependencies: JSON.stringify(plan_dependencies_array)
	// 		};
	// 		const response: any = await trackPromise(api.enrollment.getBenefitsV2(getBenefitsQuery));

	// 		if (response && response.core.length > 0) {
	// 			// for (let idx = 0; idx < response.length; idx++) {
	// 			// 	const eachPlan = response[idx];
	// 			// 	if (eachPlan.plan_name === BBI_PLAN_NAMES.health_plan) {
	// 			// 		setHasPreviousCoreEnrollment(true);
	// 			// 	}
	// 			// }
	// 			const msg = [...new Set(response.core.map((plan: any) => plan.plan_name))].join(" ");
	// 			// console.log(msg, "testinggg");
	// 			setCurrentPlanShouldEnroll({
	// 				message: `${selectedPlan.plan_name} is already included in ${msg}, to enroll into current plan ,please waive ${msg}`,
	// 				enroll: false
	// 			});
	// 		} else {
	// 			setCurrentPlanShouldEnroll({ enroll: true, message: "" });
	// 		}
	// 	} catch (e) {
	// 		console.log(e);
	// 	}
	// }, [member, selectedPlan]);

	// new code for the is_taken_together:true/false
	const checkPlanDependenciesEnrolledPriority = useCallback(async () => {
		try {
			let plan_dependencies_array: any = [];

			if (selectedPlan.plan_dependencies && selectedPlan.plan_dependencies.length > 0) {
				plan_dependencies_array = selectedPlan.plan_dependencies
					.filter((plan: any) => !plan.is_taken_together)
					.map((plan: any) => ({
						plan_name: plan.plan_name,
						plan_code: plan.plan_code
					}));
			}
			if (plan_dependencies_array.length == 0) {
				setCurrentPlanShouldEnroll({
					enroll: true,
					message: ""
				});
				return;
			}

			const getBenefitsQuery: any = {
				group_number: member.group_number,
				insured_SSN: member.SSN,
				// member_SSN: member.SSN,
				// status: "ACTIVE",
				plan_dependencies: JSON.stringify(plan_dependencies_array)
			};
			const response: any = await trackPromise(api.enrollment.getBenefitsV2(getBenefitsQuery));

			if (response && response.core.length > 0) {
				const msg = [...new Set(response.core.map((plan: any) => plan.plan_name))].join(" ");

				const takenTogetherDependency = response.core.filter((item: any) =>
					item.plan?.plan_dependencies?.some((dependency: any) => dependency.is_taken_together === true)
				);

				if (takenTogetherDependency.length === 0) {
					setCurrentPlanShouldEnroll({
						enroll: true,
						message: ""
					});
					return;
				}

				const latestEnrollment = takenTogetherDependency.sort(
					(a: any, b: any) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
				)[0];

				const isMatchingDependency = latestEnrollment?.plan?.plan_dependencies?.some(
					(dependency: any) => dependency.is_taken_together && dependency.plan_code === selectedPlan.plan_code
				);

				if (isMatchingDependency) {
					if (latestEnrollment.enrollment_status === "ACTIVE") {
						setCurrentPlanShouldEnroll({
							enroll: false,
							status: "ACTIVE",
							message: `Your ${msg} is already active.`
						});
						return;
					}

					if (latestEnrollment.enrollment_status === "SUBMITTED") {
						setCurrentPlanShouldEnroll({
							enroll: false,
							status: "SUBMITTED",
							message: `You have already submitted the ${msg}.`
						});
						return;
					}
				}
			}

			setCurrentPlanShouldEnroll({
				enroll: true,
				message: ""
			});
		} catch (e) {
			console.log(e);
		}
	}, [member, selectedPlan]);
	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		// console.log(openEnrollment, "mmm", selectedPlan, "running after ========> 222 5", member);
		if (member === null || (openEnrollment === null && selectedPlan.is_always_open === false)) {
			return;
		}
		// console.log("running after ========> 222 5", waiveReason);
		const { standardDetails, commonDetails } = generateHealthPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason,
			selectedPlan
		);
		// console.log("running after ========> 222 5", standardDetails, commonDetails);
		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			// debugger;
		}
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: { ...commonDetails, agent_id: groupOwner && groupOwner._id ? groupOwner._id : null }
		};
		// const response: any = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		// console.log("running after ========> 222 5", enrollmentPayload);
		const response: any = await trackPromise(api.enrollment.addDynamicEnrollments(enrollmentPayload));
		const step = urlSearchParams.get("step");
		if (response) {
			// console.log("branding waive submitted", response);
			setSubmittedEnrollment((prev: any) => ({ ...prev, [selectedPlan.plan_name]: response[0] }));
			await getEnrollmentInitData();
			history.push(`?step=${step}&stage=2`);
		}
	}, [history, isActiveEnrollment, member, openEnrollment, urlSearchParams, waiveReason, getEnrollmentInitData]);

	const handleWaiveButtonClick = useCallback(() => {
		if (status.openEnrollment === "CLOSED") {
			alert("Enrollment has not been opened for this plan");
			return;
		}
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							// handleWaiveEnrollment();
							setIsWaiveEnrollmentTriggered(true);
						}
					}
				]
			})
		);
	}, [customFormDialogProps, status.openEnrollment, waiveReason, selectedPlan]);

	// Get the minimum plan_order among corePlansForEmployeeClassSpecific
	const minPlanOrder = useMemo(() => {
		if (!corePlansForEmployeeClassSpecific?.length) return undefined;
		return Math.min(...corePlansForEmployeeClassSpecific.map((p: any) => p.plan_order));
	}, [corePlansForEmployeeClassSpecific]);

	// Get the plan name corresponding to the min plan_order
	const planNameIndicator = useMemo(() => {
		if (!minPlanOrder) return undefined;
		const plan = corePlansForEmployeeClassSpecific?.find((p: any) => p.plan_order === minPlanOrder);
		return plan?.plan_name;
	}, [corePlansForEmployeeClassSpecific, minPlanOrder]);

	const handleEnrollButtonClick = useCallback(() => {
		// console.log("openEnrollment", status);
		// console.log("testingggg", currentPlanShouldEnroll.enroll);
		if (status.openEnrollment === "CLOSED") {
			alert("Enrollment has not been opened for this plan. Please contact your administrator");
		} else if (!currentPlanShouldEnroll.enroll) {
			// alert(currentPlanShouldEnroll.message);
			if (currentPlanShouldEnroll.status === "ACTIVE") {
				console.log("currentPlanShouldEnroll.status", currentPlanShouldEnroll.enroll);
				setCustomFormDialogProps(
					Object.assign({}, customFormDialogProps, {
						openDialog: true,
						title: "Your Health Plan is already active. Do you want to continue with the enrollment?",
						actions: [
							{
								label: "No",
								callback: () =>
									setCustomFormDialogProps(
										Object.assign({}, customFormDialogProps, {
											openDialog: false
										})
									)
							},
							{
								label: "Yes",
								callback: () => {
									setCustomFormDialogProps(
										Object.assign({}, customFormDialogProps, {
											openDialog: false
										})
									);

									const step = urlSearchParams.get("step");
									history.push(`?step=${step}&stage=1`);
								}
							}
						]
					})
				);
			}
			if (currentPlanShouldEnroll.status === "SUBMITTED") {
				alert(currentPlanShouldEnroll.message);
			}
		} else {
			// console.log("openEnrollment22", status);

			// console.log("testinggggg", currentPlanShouldEnroll.enroll);
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=1`);
		}
	}, [history, urlSearchParams, status, currentPlanShouldEnroll.enroll, customFormDialogProps]);

	useEffect(() => {
		if (member) checkPlanDependenciesEnrolledPriority();
	}, [checkPlanDependenciesEnrolledPriority, member]);

	useEffect(() => {
		if (isWaiveEnrollmentTriggered) {
			handleWaiveEnrollment();
			setIsWaiveEnrollmentTriggered(false); // Reset the trigger
		}
	}, [isWaiveEnrollmentTriggered, handleWaiveEnrollment]);

	const branding = selectedPlan?.planDesign?.branding_design;
	const imageUrl = branding?.image ? generateFileURL(branding?.image) : null;

	// console.log("custom", customFormDialogProps);
	// console.log("====hasPreviousCoreEnrollment=====>", hasPreviousCoreEnrollment);
	// console.log("imageUrl===>", branding?.image);
	// console.log("branding.textual_details====>", branding?.textual_details);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? (
					<LazyCustomFormDialog
						customFormDialogProps={customFormDialogProps}
						planName={openEnrollment?.plan?.plan_name}
					/>
				) : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{selectedPlan.is_always_open ? (
					<PlanHeader planName={selectedPlan?.plan_name} planCode={selectedPlan?.plan_code} />
				) : (
					<PlanHeader planName={selectedPlan?.plan_name} planCode={openEnrollment?.plan?.plan_code} />
				)}
				<div className="theme-plan-section-margin" />

				{selectedPlan?.planDesign?.branding_design?.image && selectedPlan.planDesign.branding_design.logo ? (
					<div>
						<div
							style={{
								width: "160px",
								height: "56px",
								overflow: "hidden",
								marginLeft: "10px"
							}}
						>
							<LazyPlanBranding
								imgSrc={
									selectedPlan?.planDesign?.branding_design?.image
										? generateFileURL(selectedPlan.planDesign.branding_design.logo)
										: ""
								}
							/>
							{/* <img src={generateFileURL(selectedPlan?.planDesign.branding_design.logo)} alt="Branding" /> */}
						</div>
						<div
							style={{
								display: "flex",
								alignItems: "flex-start", // makes content start at top
								gap: "20px"
							}}
						>
							{/* LEFT — Branding Image */}
							<div
								style={{
									width: "360px",
									height: "200px",
									overflow: "hidden",
									borderRadius: "8px",
									boxShadow: "0 4px 14px rgba(0,0,0,0.35)"
								}}
							>
								{selectedPlan?.planDesign?.branding_design?.image ? (
									<LazyPlanBranding
										imgSrc={generateFileURL(selectedPlan.planDesign.branding_design.image)}
									/>
								) : (
									<>
										<LazyPlanBranding imgSrc={DocRxBanner} />
									</>
								)}
							</div>

							{/* RIGHT — TEXT (Starts at TOP LEFT) */}
							<div
								style={{
									flex: 1,
									display: "flex",
									// alignItems: "flex-start",
									alignItems: "center",
									justifyContent: "flex-start",
									marginTop: "-25px"
								}}
							>
								<div
									dangerouslySetInnerHTML={{
										__html: `
								<style>
									.inline-limit {
										max-height: 340px;
										max-width:550px;
										overflow: hidden;
										font-size: 11px !important;
										line-height: 1.3 !important;
									}
				
									.inline-limit * {
										font-size: 11px !important;
										line-height: 1.3 !important;
									}
				
									.inline-limit p {
										margin: 3px 0 !important;
									}
				
									.inline-limit h1,
									.inline-limit h2,
									.inline-limit h3 {
										font-size: 13px !important;
										margin: 4px 0 !important;
									}
								</style>
				
								<div class="inline-limit">
									${selectedPlan?.planDesign?.branding_design?.textual_details || ""}
								</div>
							`
									}}
								/>
							</div>
						</div>
					</div>
				) : (
					<p>No branding page available.</p>
				)}
				{/* Disclaimer for Core Plans, if 2023 Cancer is enrolled */}
				{/* {hasPreviousCoreEnrollment ? <CorePreviousBenefitDisclaimer /> : null} */}
				{selectedPlan?.plan_name === "KSOP" ? (
					<div
						style={{
							marginTop: "18px",
							display: "flex",
							justifyContent: "flex-start",
							paddingRight: "12px"
						}}
					>
						<style>
							{`
				.pop-btn {
					background: #d25119;
					color: #fff;
					border: none;
					border-radius: 20px;
					padding: 6px 14px;
					font-size: 13px;
					font-weight: 600;
					cursor: pointer;
					animation: pop 2s infinite;
					transition: transform 0.2s ease;
				}

				@keyframes pop {
					0% { transform: scale(1); }
					50% { transform: scale(1.12); }
					100% { transform: scale(1); }
				}

				.pop-btn:active {
					transform: scale(0.9);
				}
			`}
						</style>

						<span
							style={{
								fontSize: "14px",
								color: "#333",
								lineHeight: "1.5",
								display: "flex",
								alignItems: "center",
								gap: "8px",
								fontWeight: "bold"
							}}
						>
							To review the latest amendment for the KSOP plan,
							<a href={SSM} download="brookshire-smm.pdf">
								<button className="pop-btn">Download Amendment</button>
							</a>
						</span>
					</div>
				) : null}
				{isActiveEnrollment ? <CorePreviousBenefitDisclaimerV2 /> : null}
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
						handleChangePlanButtonClick={handleChangePlanButtonClick}
						buttonCaption={buttonCaption}
						planNameIndicator={selectedPlan?.plan_name}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default DynamicPlanBranding;
